import parse from "html-react-parser";
import "@/assets/css/post-content.scss";

export default function Content() {
  return (
    <main className="main-content">
      <div className="review-section">{parse(window.post_content ?? "")}</div>
    </main>
  );
}
